<template>
  <div class="usercenter">
    <div class="user_row">
      <div class="header">
        <span class="back" @click="back">{{ $t("index.back") }}</span>
      </div>
      <div class="left">
        <a-spin size="large" :spinning="infoSpining">
          <div class="card">
            <div class="card-head">{{ $t("user.aboutMe") }}</div>
            <div class="card-content headcard">
              <img :src="avatar" class="headimg" alt="..." ref="headimg" />
              <div class="flex_jc">
                <div class="leftline" :title="user.RealName">
                  {{ $t("user.name") }}：{{ user.RealName }}
                </div>
                <div class="leftline" :title="user.Account">
                  {{ $t("user.account") }}：{{ user.Account }}
                </div>
                <div class="leftline" :title="user.Email">
                  {{ $t("user.mail") }}：{{ user.Email }}
                </div>
              </div>
            </div>
          </div>
        </a-spin>
        <a-spin size="large" :spinning="vipSpining">
          <div class="card vip">
            <div class="card-head">
              <strong>{{ $t("user.vip") }}</strong
              ><span @click="shop()" style="color: #9d6748; cursor: pointer"
                >{{ $t("user.toGrowth") }} 》</span
              >
            </div>
            <div class="card-content vipCard">
              <div class="levelBox">
                <svg
                  t="1717472372855"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="3869"
                  width="23"
                  height="23"
                  style="margin-right: 5px"
                >
                  <path
                    d="M940.8 372.8l-176-219.2c-17.6-22.4-46.4-36.8-75.2-36.8H334.4c-28.8 0-56 12.8-75.2 36.8l-176 219.2c-30.4 36.8-27.2 91.2 4.8 126.4l356.8 377.6 4.8 4.8c17.6 16 41.6 25.6 65.6 25.6h3.2c25.6-1.6 49.6-11.2 67.2-30.4l348.8-376c33.6-36.8 35.2-91.2 6.4-128z m-52.8 83.2L539.2 832c-6.4 6.4-14.4 9.6-22.4 9.6-8 0-16-3.2-22.4-8L136 454.4c-11.2-11.2-11.2-28.8-1.6-41.6l174.4-219.2c6.4-8 16-12.8 25.6-12.8h355.2c9.6 0 19.2 4.8 25.6 12.8l176 219.2c8 12.8 8 30.4-3.2 43.2z"
                    :fill="vipColor"
                    p-id="3870"
                  ></path>
                  <path
                    d="M681.6 438.4L515.2 616 344 435.2c-12.8-12.8-32-14.4-46.4-1.6-12.8 11.2-12.8 32-1.6 44.8l172.8 182.4 3.2 3.2c25.6 24 65.6 22.4 91.2-3.2L729.6 480c11.2-12.8 11.2-33.6-1.6-44.8-14.4-11.2-33.6-9.6-46.4 3.2z"
                    :fill="vipColor"
                    p-id="3871"
                  ></path>
                </svg>
                Lv.{{ vipLevel }}<span class="vipName">{{ vipName }}</span>
              </div>

              <a-progress
                :stroke-color="{
                  '0%': '#f0c5a8',
                  '100%': '#e59966',
                }"
                :showInfo="false"
                :trailColor="'#FFFFFF'"
                :percent="vipPercent"
              />

              <div class="levelFooter">
                <div>
                  {{ $t("user.gValue") }}&nbsp<strong>{{ integral }}&nbsp</strong>/
                  {{ vipLeft }}
                </div>
                <div>
                  {{ $t("user.next1") }}&nbsp{{ vipNext }}&nbsp{{ $t("user.next2") }}
                </div>
              </div>
            </div>
          </div>
        </a-spin>
        <div class="card">
          <div class="card-head">{{ $t("service.center") }}</div>
          <div class="card-content serviceCard">
            <div class="serviceItem" @click="jump('policy')">
              <img
                class="serviceImg"
                src="@/assets/img/icon/服务政策.svg"
                alt="服务政策"
              />
              <p class="serviceTitle">{{ $t("service.policy") }}</p>
            </div>
            <div class="serviceItem" @click="jump('standards')">
              <img
                class="serviceImg"
                src="@/assets/img/icon/服务标准.svg"
                alt="服务标准"
              />
              <p class="serviceTitle">{{ $t("service.standards") }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="right">
        <a-spin size="large" :spinning="addressSpining">
          <div class="card">
            <div class="card-head">{{ $t("user.basicInfo") }}</div>
            <div class="card-content">
              <a-form :model="user" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-form-item :label="$t('user.account')">
                  <a-input
                    v-model:value="user.Account"
                    :disabled="true"
                    autocomplete="false"
                  />
                </a-form-item>
                <a-form-item :label="$t('user.mail')">
                  <a-input
                    v-model:value="user.Email"
                    :disabled="true"
                    autocomplete="false"
                  />
                </a-form-item>
                <a-form-item :label="$t('user.phone')">
                  <a-input
                    v-model:value="user.Mobile"
                    :disabled="true"
                    autocomplete="false"
                  />
                </a-form-item>
                <a-form-item :label="$t('user.name')">
                  <a-input v-model:value="user.RealName" autocomplete="false" />
                </a-form-item>
                <a-form-item :label="$t('user.address')">
                  <a-cascader
                    style="width: 100%"
                    v-model:value="address"
                    :options="addressList"
                    :load-data="loadData"
                    :fieldNames="addressFieldNames"
                    @change="onChange"
                  />
                </a-form-item>
                <a-form-item :label="$t('user.oldPass')">
                  <a-input-password
                    autocomplete="false"
                    v-model:value="oldpasswordvalue"
                    :placeholder="$t('user.passwordIn')"
                  />
                </a-form-item>
                <a-form-item :label="$t('user.newPass')">
                  <a-input-password
                    autocomplete="false"
                    v-model:value="newpasswordvalue"
                    :placeholder="$t('user.passwordIn')"
                  />
                </a-form-item>
                <a-form-item :label="$t('user.confirmPass')">
                  <a-input-password
                    autocomplete="false"
                    v-model:value="newpasswordvalue2"
                    :placeholder="$t('user.passwordIn')"
                  />
                </a-form-item>
                <div class="bottomLine" style="margin-bottom: 13px">
                  <a-button
                    class="submitbtn"
                    type="primary"
                    @click="submit"
                    :loading="subLoad"
                    >{{ $t("user.save") }}</a-button
                  >

                  <a-button @click="changeEmail">{{ $t("user.changeEmail") }}</a-button>
                </div>
              </a-form>
            </div>
          </div>
        </a-spin>
      </div>
    </div>
    <div class="user_row" style="padding-top: 0px">
      <div class="card warranty_card" style="margin-top: 0px">
        <div class="card-head">{{ $t("user.question") }}</div>
        <div class="card-content warranty_content">
          <a-row :gutter="24" style="margin-bottom: 30px">
            <a-col :span="8">
              <a-input
                v-model:value="questionFormState.searchKey"
                :placeholder="$t('user.questionin')"
              />
            </a-col>
            <a-col :span="16">
              <a-button type="primary" @click="searchQuestion()">
                <template #icon>
                  <SearchOutlined />
                </template>
                {{ $t("user.search") }}
              </a-button>
              <a-button class="snowy-buttom-left" @click="questionReset">
                <template #icon><redo-outlined /></template>
                {{ $t("user.reset") }}
              </a-button>
              <a-button class="snowy-buttom-left" @click="newQuestion">
                <template #icon><upload-outlined /></template>
                {{ $t("user.newQuestion") }}
              </a-button>
            </a-col>
          </a-row>
          <a-table
            :loading="questionLoading"
            ref="questionTable"
            :columns="questionColumns"
            :dataSource="questionDataSource"
            bordered
            :row-key="(record) => record.Id"
            :tool-config="toolConfig"
          >
            <template #bodyCell="{ column, record }">
              <template v-if="column.dataIndex === 'IsComplaint'">
                <a-tag v-if="record.IsComplaint == '1'" color="red">
                  {{ $t("user.urgent") }}
                </a-tag>
                <a-tag v-else color="green"> {{ $t("user.noUrgent") }} </a-tag>
              </template>
              <template v-if="column.dataIndex === 'ProcessingStatus'">
                <a-tag v-if="record.ProcessingStatus == '0'" color="green">
                  {{ $t("user.progress") }}
                </a-tag>
                <a-tag v-else color="blue"> {{ $t("user.completed") }} </a-tag>
              </template>
              <template v-if="column.dataIndex === 'action'">
                <a-space>
                  <a @click="ckeck(record)" style="color: #1890ff">
                    {{ $t("user.check") }}</a
                  ></a-space
                >
                <a-divider type="vertical" />
                <a-space>
                  <a v-if="record.ProcessingStatus == '1'" class="ended">
                    {{ $t("user.ended") }}</a
                  >
                  <a
                    v-if="record.IsComplaint == '1' && record.ProcessingStatus != '1'"
                    class="ended"
                  >
                    {{ $t("user.urgented") }}</a
                  >
                  <a
                    v-if="record.IsComplaint != '1' && record.ProcessingStatus != '1'"
                    @click="complaint(record)"
                    style="color: #cf1322"
                  >
                    {{ $t("user.complaint") }}</a
                  >
                </a-space>
              </template>
            </template>
          </a-table>
        </div>
      </div>
    </div>
    <div class="user_row" style="padding-top: 0px">
      <div class="card warranty_card" style="margin-top: 0px">
        <div class="card-head">{{ $t("user.warranty") }}</div>
        <div class="card-content warranty_content">
          <a-row :gutter="24" style="margin-bottom: 30px">
            <a-col :span="8">
              <a-input
                v-model:value="searchFormState.searchKey"
                :placeholder="$t('user.orderin')"
              />
            </a-col>
            <a-col :span="8">
              <a-button type="primary" @click="searchWarranty()">
                <template #icon>
                  <SearchOutlined />
                </template>
                {{ $t("user.search") }}
              </a-button>
              <a-button class="snowy-buttom-left" @click="reset">
                <template #icon><redo-outlined /></template>
                {{ $t("user.reset") }}
              </a-button>
            </a-col>
          </a-row>
          <a-table
            :loading="warrantyLoading"
            ref="table"
            :columns="columns"
            :dataSource="dataSource"
            bordered
            :row-key="(record) => record.Id"
            :tool-config="toolConfig"
          ></a-table>
        </div>
      </div>
    </div>
    <a-modal
      v-model:open="modalOpen"
      :title="$t('user.changeEmail')"
      :ok-text="$t('index.submit')"
      :cancel-text="$t('index.cancel')"
      @ok="submitEmail"
      @cancel="cancelModal"
    >
      <a-form
        ref="modalFormRef"
        :model="modalFormState"
        layout="vertical"
        name="changeEmail"
      >
        <a-form-item
          name="email"
          :label="$t('register.email')"
          :rules="[{ required: true, message: $t('register.emailEmpty') }]"
        >
          <a-input v-model:value="modalFormState.email" :disabled="emailDis" />
        </a-form-item>
        <a-form-item
          :label="$t('user.code')"
          name="code"
          :rules="[{ required: true, message: $t('register.codeEmpty') }]"
        >
          <a-row :gutter="12">
            <a-col :span="16">
              <a-input
                v-model:value="modalFormState.code"
                :placeholder="$t('register.codein')"
              />
            </a-col>
            <a-col :span="8">
              <a-form-item-rest>
                <div :class="[isDisabled ? 'disabledbtn' : 'codebtn']" @click="emailCode">
                  <span ref="codeinfo">{{ $t("register.getCode") }}</span>
                </div>
              </a-form-item-rest>
            </a-col>
          </a-row>
        </a-form-item>
      </a-form>
    </a-modal>
    <a-drawer v-model:open="drawerOpen" :title="$t('user.questionTitle')" width="1000px">
      <p>
        <span style="margin-right: 20px">{{ $t("user.basicInfo") }}</span>
        <a-tag v-if="nowQuestion.ProcessingStatus == '0'" color="green">
          {{ $t("user.progress") }}
        </a-tag>
        <a-tag v-else color="blue"> {{ $t("user.completed") }} </a-tag>
      </p>
      <a-descriptions bordered style="margin-bottom: 20px">
        <a-descriptions-item :label="$t('user.product')">{{
          nowQuestion.Product
        }}</a-descriptions-item>
        <a-descriptions-item :label="$t('user.version')">{{
          nowQuestion.Version
        }}</a-descriptions-item>
        <a-descriptions-item :label="$t('user.person')">{{
          nowQuestion.UserName
        }}</a-descriptions-item>
        <a-descriptions-item :label="$t('user.contact')">{{
          nowQuestion.Phone
        }}</a-descriptions-item>
        <a-descriptions-item :label="$t('user.questionTitle')">{{
          nowQuestion.Title
        }}</a-descriptions-item>
        <a-descriptions-item :label="$t('user.time')">{{
          nowQuestion.CreateTime
        }}</a-descriptions-item>
        <a-descriptions-item :label="$t('user.isComplaint')">
          <a-tag v-if="nowQuestion.IsComplaint == '1'" color="red">
            {{ $t("user.urgent") }}
          </a-tag>
          <a-tag v-else color="green">
            {{ $t("user.noUrgent") }}
          </a-tag></a-descriptions-item
        >
        <a-descriptions-item :label="$t('user.want')">{{
          nowQuestion.ExProcessingTime
        }}</a-descriptions-item>
        <a-descriptions-item :label="$t('user.reality')">{{
          nowQuestion.ProcessingTime
        }}</a-descriptions-item>
      </a-descriptions>
      <p>{{ $t("user.step") }}</p>
      <a-typography class="step" v-html="nowQuestion.HtmlContent"></a-typography>
      <a-divider />
      <p>Bnt{{ $t("user.file") }}</p>
      <a-upload
        v-model:file-list="fileListBnt"
        name="fileBnt"
        :maxCount="1"
        :showUploadList="true"
        :customRequest="customRequestOther"
        @remove="handleRemove"
        :before-upload="beforeUpload"
        @preview="previewFile"
      >
        <template #removeIcon></template>
      </a-upload>
      <a-divider />
      <p>igs/stp{{ $t("user.file") }}</p>
      <a-upload
        v-model:file-list="fileListOther"
        :customRequest="customRequestOther"
        name="fileOther"
        :maxCount="1"
        :showUploadList="true"
        @remove="handleRemove"
        :before-upload="beforeUpload"
        @preview="previewFile"
      >
        <template #removeIcon></template>
      </a-upload>
      <a-divider />
    </a-drawer>
  </div>
</template>

<script setup>
import { ref, computed, reactive } from "vue";
import { useRouter } from "vue-router";
import axios from "axios";
import { message, Modal } from "ant-design-vue";
import { useI18n } from "vue-i18n";
import { SearchOutlined, RedoOutlined, UploadOutlined } from "@ant-design/icons-vue";

const { t } = useI18n();

const infoSpining = ref(false);
const addressSpining = ref(false);
let router = useRouter();

let oldpasswordvalue = ref(null);
let newpasswordvalue = ref(null);
let newpasswordvalue2 = ref(null);
let subLoad = ref(false);
const phone = ref(null);
let warninfo = ref("");
let user = ref(JSON.parse(localStorage.getItem("user")));
let userId = localStorage.getItem("userId");
let labelCol = { span: 5 };
let wrapperCol = { span: 19 };
let address = ref();
const addressFieldNames = { label: "countryname", value: "countryid" };
const addressList = ref([]);
const avatar = ref();
const vipSpining = ref(false);
const integral = ref(0);
const table = ref(null);
const dataSource = ref([]);
const warrantyLoading = ref(false);
const toolConfig = { refresh: true, height: true, columnSetting: false, striped: false };
const userDevice = ref([]);
const modalOpen = ref(false);
const modalFormState = ref({});
const modalFormRef = ref();
const VCode = ref(null);
let count = ref(60);
const codeinfo = ref(null);
let isDisabled = ref(false);
const emailDis = ref(false);
let intervalId; // 添加此变量，用于存储定时器的ID
const questionTable = ref(null);
const questionDataSource = ref([]);
const questionLoading = ref(false);
const startCountdown = () => {
  intervalId = setInterval(() => {
    if (count.value > 0) {
      codeinfo.value.textContent = count.value + "s" + t("register.wait");
      count.value--;
    } else {
      clearInterval(intervalId);
      codeinfo.value.textContent = t("register.getCode");
      isDisabled.value = false;
    }
  }, 1000);
};
const drawerOpen = ref(false);
const nowQuestion = ref({});
const fileListBnt = ref([]);
const fileListOther = ref([]);

let searchFormState = reactive({});
let questionFormState = reactive({});
const vipColor = computed(() => {
  return integral.value <= 5000
    ? "#05e113"
    : integral.value <= 10000
    ? "#1296db"
    : integral.value <= 20000
    ? "#cc33ff"
    : integral.value <= 30000
    ? "#cc33ff"
    : "#ff0000";
});
const vipLevel = computed(() => {
  return integral.value <= 5000
    ? 1
    : integral.value <= 10000
    ? 2
    : integral.value <= 20000
    ? 3
    : integral.value <= 30000
    ? 4
    : 5;
});
const vipName = computed(() => {
  return integral.value <= 5000
    ? t("user.level1")
    : integral.value <= 10000
    ? t("user.level2")
    : integral.value <= 20000
    ? t("user.level3")
    : integral.value <= 30000
    ? t("user.level4")
    : t("user.level5");
});
const vipLeft = computed(() => {
  return integral.value <= 5000
    ? 5000
    : integral.value <= 10000
    ? 10000
    : integral.value <= 20000
    ? 20000
    : integral.value <= 30000
    ? 30000
    : "--";
});
const vipPercent = computed(() => {
  return integral.value <= 30000 ? (integral.value / vipLeft.value) * 100 : 100;
});
const vipNext = computed(() => {
  return integral.value <= 30000 ? vipLeft.value - integral.value : "--";
});

const filter = (inputValue, path) => {
  return path.some(
    (option) => option.countryname.toLowerCase().indexOf(inputValue.toLowerCase()) > -1
  );
};

function getUser() {
  infoSpining.value = true;
  addressSpining.value = true;
  axios
    .post("api/User/GetUsers", { UserId: userId })
    .then((response) => {
      if (response.data.code != 200) {
        message.error(response.data.info);
      } else {
        user.value = response.data.ReturnData[0];
        localStorage.setItem("user", JSON.stringify(user.value));
        avatar.value = user.value.Url
          ? "https://apicloud.bodor.com" + user.value.Url
          : require("@/assets/img/header.png");
      }
    })
    .catch((error) => {
      console.error(error);
    })
    .finally(() => {
      infoSpining.value = false;
      addressSpining.value = false;
      fetchAddressAndHandleResponse();
    });
}
getUser();

function getVip() {
  vipSpining.value = true;
  axios
    .post("api/User/GetMallPoints")
    .then((response) => {
      vipSpining.value = false;
      if (response.data.code != 200) {
        message.error(response.data.info);
      } else {
        integral.value = response.data.ReturnData;
      }
    })
    .catch((error) => {
      console.error(error);
    });
}
getVip();
searchQuestion();

function getDevice() {
  axios
    .post("api/Machine/GetMyMachine", { UserId: userId })
    .then((response) => {
      if (response.data.code != 200) {
        message.error("获取用户设备失败!");
      } else {
        userDevice.value = response.data.ReturnData;
      }
    })
    .catch((error) => {
      console.error(error);
    })
    .finally(() => {
      searchWarranty();
    });
}
warrantyLoading.value = true;
getDevice();

function searchWarranty() {
  warrantyLoading.value = true;
  let newStr = searchFormState.searchKey;
  if (searchFormState.searchKey) {
    newStr = searchFormState.searchKey.replace(/\s+/g, "");
    axios
      .post("api/QualityAssurance/GetList", {
        OrderNumber: newStr,
      })
      .then((response) => {
        warrantyLoading.value = false;
        if (response.data.code != 200) {
          message.error(response.data.info);
        } else {
          dataSource.value = response.data.ReturnData;
        }
      })
      .catch((error) => {
        console.error(error);
      });
  } else {
    dataSource.value = [];
    if (Array.isArray(userDevice.value)) {
      userDevice.value.forEach((data) => {
        axios
          .post("api/QualityAssurance/GetList", {
            OrderNumber: data.ordernumber,
          })
          .then((response) => {
            warrantyLoading.value = false;
            if (response.data.code != 200) {
              console.error(response.data.info);
            } else {
              if (response.data.ReturnData[0]) {
                dataSource.value.push(response.data.ReturnData[0]);
              }
            }
          })
          .catch((error) => {
            console.error(error);
          });
      });
    } else {
      warrantyLoading.value = false;
    }
  }
}

const onChange = (_value, selectedOptions) => {
  user.value.FullPathId = _value.join("-");
  user.value.FullPathName = selectedOptions
    .map((country) => country.countryname)
    .join("/");
};

function parseStringToArray(inputString) {
  // 使用正则表达式匹配数字
  if (inputString) {
    const numbers = inputString.match(/\d+/g);

    // 如果没有匹配到数字，返回空数组
    if (!numbers) {
      return [];
    }

    // 将匹配到的数字字符串转换为整数
    return numbers.map(Number);
  } else {
    return [];
  }
}

async function getAddress(type, parentId) {
  type = type.toString();
  parentId = parentId.toString();
  try {
    const response = await axios.post("api/User/GetAreaData", {
      seltype: type,
      fid: parentId,
    });
    if (response.data.code !== 200) {
      message.error(response.data.info);
    } else {
      return response.data.ReturnData;
    }
  } catch (error) {
    console.error(error);
    return []; // 返回一个错误对象
  }
}

function findCountry(countryArray, targetId) {
  if (countryArray.length > 0) {
    return countryArray[countryArray.findIndex((obj) => obj.countryid === targetId)];
  }
}

async function fetchAddressAndHandleResponse() {
  //将1-2-3转义为[1, 2, 3]的格式
  let userFullPathId = parseStringToArray(user.value.FullPathId);
  try {
    addressList.value = await getAddress("1", "");
    addressList.value.forEach((element) => {
      element.isLeaf = false;
      element.type = 1;
    });
    if (userFullPathId.length > 0) {
      let firOption = findCountry(addressList.value, userFullPathId[0]);
      for (let i = 0; i < userFullPathId.length - 1; i++) {
        let targetOption =
          i == 0
            ? firOption
            : i == 1
            ? findCountry(firOption.children, userFullPathId[1])
            : i == 2
            ? findCountry(
                findCountry(firOption.children, userFullPathId[1]).children,
                userFullPathId[2]
              )
            : findCountry(
                findCountry(
                  findCountry(firOption, userFullPathId[1]).children,
                  userFullPathId[2]
                ).children,
                userFullPathId[3]
              );
        let addressData = await getAddress(i + 2, userFullPathId[i]);
        if (addressData.length > 0) {
          addressData.forEach((element) => {
            element.isLeaf = i + 2 < 4 ? false : true;
            element.type = i + 2;
          });

          targetOption.children = addressData;
        } else {
          targetOption.isLeaf = true;
        }
        addressList.value = [...addressList.value];
      }
      address.value = userFullPathId;
    }
  } catch (error) {
    console.error("Error fetching address:", error);
  }
}

const loadData = (selectedOptions) => {
  const targetOption = selectedOptions[selectedOptions.length - 1];
  targetOption.loading = true;
  async function fetchAddressAndHandle() {
    try {
      let addressData = await getAddress(targetOption.type + 1, targetOption.countryid);
      targetOption.loading = false;
      if (addressData.length > 0) {
        addressData.forEach((element) => {
          element.isLeaf = targetOption.type + 1 < 4 ? false : true;
          element.type = targetOption.type + 1;
        });
        targetOption.children = addressData;
      } else {
        targetOption.isLeaf = true;
      }
      addressList.value = [...addressList.value];
    } catch (error) {
      console.error("Error fetching address:", error);
    }
  }
  fetchAddressAndHandle();
};

const submit = () => {
  if (!user.value.RealName) {
    message.error(t("user.nameErr"));
    return;
  }
  if (user.value.Mobile) {
    var reg = /[\d]/;
    if (!reg.test(user.value.Mobile)) {
      message.error(t("user.phoneErr"));
      return;
    }
  }
  subLoad.value = true;
  axios
    .post("api/User/Save", user.value)
    .then(function (response) {
      if (response.data.code != 200) {
        message.error(response.data.info);
      } else {
        message.success(response.data.ReturnData);
      }
    })
    .catch(function (error) {})
    .finally(() => {
      subLoad.value = false;
      if (newpasswordvalue.value) {
        if (!oldpasswordvalue.value) {
          message.error(t("user.oldErr"));
          return;
        } else if (newpasswordvalue2.value != newpasswordvalue.value) {
          message.error(t("user.newErr"));
          return;
        }
        subLoad.value = true;
        axios
          .post("api/User/PasswordReset", {
            UserId: user.value.UserId,
            Password: newpasswordvalue.value,
            ConfirmPassword: newpasswordvalue2.value,
          })
          .then(function (response) {
            if (response.data.code != 200) {
              message.error(response.data.info);
            } else {
              message.success(response.data.ReturnData);
            }
          })
          .catch(function (error) {})
          .finally(() => {
            oldpasswordvalue.value = null;
            newpasswordvalue.value = null;
            newpasswordvalue2.value = null;
            subLoad.value = false;
            getUser();
          });
      }
    });
};

function changeEmail() {
  modalOpen.value = true;
}

function cancelModal() {
  modalOpen.value = false;
  emailDis.value = false;
  clearInterval(intervalId);
  codeinfo.value.textContent = t("register.getCode");
  isDisabled.value = false;
}

function submitEmail() {
  if (VCode.value != modalFormState.value.code) {
    message.error(t("register.codeErr"));
    return;
  } else {
    let params = JSON.parse(localStorage.getItem("user"));
    params.Email = modalFormState.value.email;
    modalFormRef.value
      .validate()
      .then(() => {
        axios
          .post("api/User/Save", params)
          .then(function (response) {
            if (response.data.code != 200) {
              message.error(response.data.info);
            } else {
              location.reload();
              message.success(response.data.ReturnData);
            }
            modalOpen.value = false;
            emailDis.value = false;
          })
          .catch(function (error) {});
      })
      .catch(() => {});
  }
}

const emailCode = () => {
  if (!isDisabled.value) {
    if (modalFormState.value.email) {
      axios
        .post("api/User/GetUserEmail", {
          Email: modalFormState.value.email,
        })
        .then(function (response) {
          if (response.data.code != 200) {
            message.error(response.data.info);
          } else {
            if (response.data.ReturnData.length > 0) {
              message.error(t("register.emailDuplicate"));
            } else {
              emailDis.value = true;
              isDisabled.value = true;
              count.value = 60;
              startCountdown();
              axios
                .post("api/User/RegisterEmlie", {
                  Email: modalFormState.value.email,
                })
                .then(function (response) {
                  if (response.data.code != 200) {
                    message.error(response.data.info);
                  } else {
                    VCode.value = response.data.ReturnData;
                  }
                })
                .catch(function (error) {});
            }
          }
        })
        .catch(function (error) {});
    } else {
      message.error(t("register.emailEmpty"));
      return;
    }
  }
};

function searchQuestion() {
  if (user.value.Mobile) {
    let newStr = questionFormState.searchKey;
    if (questionFormState.searchKey) {
      newStr = questionFormState.searchKey.replace(/\s+/g, "");
    }
    questionLoading.value = true;
    axios
      .post("api/Cam/GetProblemFeedbacks", {
        Id: "", //问题反馈Id
        Phone: user.value.Mobile, //联系方式
        Title: newStr, //问题标题
        IsComplaint: "", //加急状态（1：加急）
        ProcessingStatus: "", //处理状态（0：进行中 1：已完成）
      })
      .then(function (response) {
        questionLoading.value = false;
        if (response.data.code != 200) {
          message.error(response.data.info);
        } else {
          questionDataSource.value = response.data.ReturnData;
        }
      })
      .catch(function (error) {});
  }
}

function newQuestion() {
  const routeUrl = router.resolve({
    name: "userReport",
  });
  window.open(routeUrl.href, "_blank");
}

/**加急 */
function complaint(record) {
  console.log(record);
  axios
    .post("api/Cam/UpdateComplaint", {
      Id: record.Id, //问题反馈Id
      IsComplaint: "1", //加急状态（0：不加急 1：急单）
    })
    .then(function (response) {
      if (response.data.code != 200) {
        message.error(response.data.info);
      } else {
        message.success(t("user.urgentsucc"));
        searchQuestion();
      }
    })
    .catch(function (error) {});
}

const questionReset = () => {
  questionFormState.searchKey = null;
  searchQuestion();
};

const reset = () => {
  searchFormState.searchKey = null;
  searchWarranty();
};

function ckeck(record) {
  drawerOpen.value = true;
  nowQuestion.value = Object.assign({}, record);
  fileListBnt.value = [];
  fileListOther.value = [];

  if (nowQuestion.value.BntFile) {
    fileListBnt.value.push({
      uid: "1",
      name: nowQuestion.value.BntFileName,
      status: "done",
      url: "https://apicloud.bodor.com" + nowQuestion.value.BntFile,
    });
  }
  if (nowQuestion.value.OtherFile) {
    fileListOther.value.push({
      uid: "2",
      name: nowQuestion.value.OtherFileName,
      status: "done",
      url: "https://apicloud.bodor.com" + nowQuestion.value.OtherFile,
    });
  }
}

function previewFile(file) {
  message.info("已开始下载，请耐心等待");
  let url = file.url;
  let name = file.name;
  // 发送http请求，将文件链接转换成文件流
  let xhr = new XMLHttpRequest();
  xhr.open("get", url, true);
  // 请求类型
  xhr.responseType = "blob";
  xhr.onreadystatechange = function () {
    // 获取接口结果
    if (xhr.readyState === 4 && xhr.status === 200) {
      window.URL = window.URL || window.webkitURL;
      let a = document.createElement("a");
      let blob = new Blob([xhr.response]);
      // 通过二进制文件创建url
      let url = window.URL.createObjectURL(blob);
      a.href = url;
      a.download = name;
      a.click();
      // 销毁创建的url
      window.URL.revokeObjectURL(url);
    }
  };
  xhr.send();
}

function customRequestOther(file) {
  message.info("此乃客户上传之文件,不可更改");
}

const handleRemove = (file) => {
  return false;
};

const beforeUpload = (file) => {
  return false;
};

/**跳转商城 */
function shop() {
  let link = document.createElement("a");
  //创建一个a标签
  link.style.display = "none";
  //将a标签隐藏
  link.href = "http://t.weimob.com/AO_N0Lp";
  link.setAttribute("target", "_blank");
  document.body.appendChild(link);
  //将上面创建的a标签加入到body的尾部
  link.click();
}

const back = () => {
  router.push(`/index/software`);
};

function jump(url) {
  router.push(`/${url}`);
}

const columns = [
  {
    title: t("user.orderNumber"),
    dataIndex: "OrderNumber",
  },
  {
    title: t("user.deliveryTime"),
    dataIndex: "DeliveryTime",
  },
  {
    title: t("user.marketingDept"),
    dataIndex: "MarketingDept",
  },
  {
    title: t("user.belongDept"),
    dataIndex: "BelongDept",
  },
  {
    title: t("user.laserBrand"),
    dataIndex: "LaserBrand",
  },
  {
    title: t("user.extdWarrantyTime"),
    dataIndex: "ExtdWarrantyTime",
  },
  {
    title: t("user.guaranteeTime"),
    dataIndex: "GuaranteeTime",
  },
  {
    title: t("user.isGuarantee"),
    dataIndex: "IsGuarantee",
  },
  {
    title: t("user.extdWarrantyType"),
    dataIndex: "ExtdWarrantyType",
  },
];

const questionColumns = [
  {
    title: t("user.questionTitle"),
    dataIndex: "Title",
  },
  {
    title: t("user.product"),
    dataIndex: "Product",
  },
  {
    title: t("user.version"),
    dataIndex: "Version",
  },
  {
    title: t("user.processingStatus"),
    dataIndex: "ProcessingStatus",
  },
  {
    title: t("user.isComplaint"),
    dataIndex: "IsComplaint",
  },
  {
    title: t("user.action"),
    dataIndex: "action",
    align: "center",
    width: "200px",
  },
];
</script>

<style scoped>
.ant-input {
  border-radius: 0px !important;
}
.ant-input-affix-wrapper {
  border-radius: 0px !important;
}
.usercenter {
  background-color: #f7f9fa;
  width: 100%;
  min-height: 100%;
}
.user_row {
  width: 1200px;
  min-width: 1200px;
  margin: 0 auto;
  font-size: 16px;
  color: black;
  position: relative;
  padding: 50px 0px 0px 0px;
  display: flex;
  justify-content: space-between;
}

.header {
  height: 50px;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  border-bottom: 1px solid #e6e6e6;
  background: rgba(255, 255, 255, 0.24);
  -webkit-backdrop-filter: blur(20px);
  backdrop-filter: blur(20px);
  z-index: 999;
  padding-left: 50px;
}
.back {
  height: 50px;
  line-height: 50px;
  color: #0099ff;
  margin-right: 80px;
  font-weight: bold;
  font-size: 20px;
  cursor: pointer;
}
.card {
  box-sizing: border-box;
  border: none;
  border-radius: 4px;
  -webkit-box-shadow: 0 1px 2px 1px rgba(0, 0, 0, 0.16);
  box-shadow: 0 1px 2px 1px rgba(0, 0, 0, 0.16);
  margin: 20px 0px;
  overflow: visible;
  transition: all 0.4s;
  font-size: 14px;
  background-color: white;
}
.card:hover {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.16), 0 1px 2px 1px rgba(0, 0, 0, 0.16);
}
.card:hover {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.16), 0 1px 2px 1px rgba(0, 0, 0, 0.16);
}
.card-head {
  width: 100%;
  align-items: center;
  color: #333;
  display: flex;
  justify-content: space-between;
  padding: 12px 15px;
}
.card-content {
  width: 100%;
  min-height: 50px;
  padding: 15px;
  display: flex;
}
.left {
  width: 440px;
}
.leftcard {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.headcard {
  width: 100%;
  display: flex;
}
.right {
  width: 740px;
  display: flex;
  flex-direction: column;
}
.headimg {
  width: 100px;
  height: 100px;
  border: 1px solid #e3e4e6;
  border-radius: 4px;
  margin: 0px 40px 10px 30px;
}
.userinfo {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  margin-left: 15px;
}
.leftline {
  font-size: 14px;
  line-height: 18px;
  margin-bottom: 10px;
  width: 100%;
  overflow: hidden; /*超过部分不显示*/
  text-overflow: ellipsis; /*超过部分用点点表示*/
  white-space: nowrap; /*不换行*/
}
.infoline {
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 25px;
  padding: 0;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  vertical-align: top;
  height: 32px;
}
.infoname {
  font-size: 14px;
  text-align: right;
  width: 15%;
}
.inputbox {
  width: 65%;
  min-width: 0;
  padding: 4px 11px;
  font-size: 14px;
  line-height: 1.5715;
  background-color: white;
  background-image: none;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
  transition: all 0.3s;
  display: inline-flex;
}
form {
  width: 100%;
}
input {
  outline: none;
}
.inputbox:focus {
  border-color: #40a9ff;
  box-shadow: 0 0 0 2px #bae7ff;
  border-right-width: 1px !important;
  outline: 0;
}
.leftbottom {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  position: relative;
  box-sizing: border-box;
  align-items: center;
  justify-content: space-between;
  margin-top: 10px;
}
.bottomLine {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.infoitems {
  border-color: #c0c6cc;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
  height: 80px;
  position: relative;
  text-align: left;
  border-radius: 4px;
  padding: 12px;
  width: 48%;
  text-decoration: none;
  background: #f7f9fa;
  border: 1px solid transparent;
  transition: all 0.1s linear;
}
.infoitems:hover {
  border-color: #c0c6cc;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
}
.infotitle {
  line-height: 18px;
  height: 18px;
  color: #555;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 18px;
  height: 18px;
}
.infonumber {
  display: block;
  line-height: 50px;
  height: 50px;
  font-size: 18px;
  font-weight: 500;
  color: #333;
  width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.submitbtn {
  margin-right: 20px;
  color: #fff;
  border-color: #1890ff;
  background: #1890ff;
  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.12);
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045);
  line-height: 1.5715;
  position: relative;
  display: inline-block;
  font-weight: 400;
  white-space: nowrap;
  text-align: center;
  border: 1px solid transparent;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  user-select: none;
  touch-action: manipulation;
  height: 32px;
  padding: 4px 15px;
  font-size: 14px;
  border-radius: 2px;
}
.submitbtn:hover {
  color: #fff;
  border-color: #40a9ff;
  background: #40a9ff;
}
.warninfo {
  margin-left: 20px;
  color: red;
}
.serviceCard {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
}
.serviceItem {
  width: 150px;
  height: 150px;
  background: white;
  box-shadow: rgba(0, 0, 0, 0.4) 0px 2px 4px;
  margin-bottom: 10px;
  transition: all, 0.4s;
  cursor: pointer;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: space-evenly;
  flex-wrap: wrap;
  text-align: center;
  white-space: pre-wrap;
}
.serviceItem:hover {
  box-shadow: rgba(0, 0, 0, 0.4) 0px 2px 4px, rgba(0, 0, 0, 0.3) 0px 7px 13px -3px,
    rgba(0, 0, 0, 0.2) 0px -3px 0px inset;
}
.serviceIcon {
  width: 40px;
  height: 40px;
}
.serviceTitle {
  line-height: 30px;
  font-family: PingFangSC-Medium, sf-pro-text_medium, PingFang SC, "Microsoft YaHei";
  font-weight: 500;
  font-size: 20px;
  margin-bottom: 0px;
}
.vip {
  background-image: linear-gradient(to bottom right, #f5d7c3 0%, #ffffff 100%);
  /*   background: linear-gradient(
    180deg,
    rgba(0, 255, 255, 1) 0%,
    rgba(255, 150, 255, 1) 100%
  ); */
}
.vipCard {
  display: flex;
  flex-direction: column;
  padding: 5px 15px 15px 15px;
}
.levelBox {
  font-weight: bold;
  font-size: 24px;
  display: flex;
  align-items: center;
}
.levelBox > svg {
  margin-right: 5px;
}
.levelFooter {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.vipName {
  font-size: 12px;
  margin-left: 5px;
  font-weight: normal;
  align-self: flex-end;
  margin-bottom: 4px;
}
.flex_jc {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: hidden;
}
.warranty_card {
  width: 100%;
}
.warranty_content {
  flex-direction: column;
}
.snowy-buttom-left {
  margin-left: 8px;
}
.disabledbtn {
  background-color: gray;
  cursor: not-allowed;
  display: inline-block;
  border-radius: 4px;
  border: none;
  color: #ffffff;
  text-align: center;
  width: 100%;
  height: 32px;
  line-height: 32px;
}
.codebtn {
  display: inline-block;
  border-radius: 4px;
  background-color: #3d405b;
  border: none;
  color: #ffffff;
  text-align: center;
  width: 100%;
  height: 32px;
  line-height: 32px;
  transition: all 0.5s;
  cursor: pointer;
}
.ended {
  color: gray;
  cursor: not-allowed;
}

.codebtn span {
  cursor: pointer;
  display: inline-block;
  position: relative;
  transition: 0.5s;
}

.codebtn span:after {
  content: "»";
  position: absolute;
  opacity: 0;
  top: 0;
  right: -15px;
  transition: 0.5s;
}

.codebtn:hover span {
  padding-right: 15px;
}

.codebtn:hover span:after {
  opacity: 1;
  right: 0;
}
.step {
  font-family: Menlo, Monaco, Consolas, -apple-system, BlinkMacSystemFont, "Segoe UI",
    Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji",
    "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
}
:deep(a) {
  color: rgb(24, 144, 255);
}
</style>
